<template>
  <div id="eixo-social">
    <div id="page">
      <div id='cardsSMS' class="row topCardGrid">
        <sp-card :valor="populacaoTotal" :descricao="$t('eixos.social.topCards.populacaoTitle')" classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.social.topCards.populacaoFooter')" icon="fa fa-users boldness cor1"></sp-card>
        <sp-card :valor="orcamentoSaude" :descricao="$t('eixos.social.topCards.fundosSaudeTitle')" classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.social.topCards.fundosSaudeFooter')" icon="fa fa-money boldness cor1"></sp-card>
        <sp-card :valor="totalFarmacias" :descricao="$t('eixos.social.topCards.farmaciasTitle')" classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.social.topCards.farmaciasFooter')" icon="fa fa-heartbeat boldness cor1" ></sp-card>
        <sp-card :valor="estoquePorMedicamento.length" :descricao="$t('eixos.social.topCards.medicamentosTitle')" classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.social.topCards.medicamentosFooter')" icon="fa fa-medkit boldness cor1" ></sp-card>
      </div>
      <div id='cardsSME' class="row topCardGrid">
        <sp-card :valor="numerosRedeEnsino.totalMatriculasCreche" :descricao="$t('eixos.social.topCards.matriculaCrecheCard')" classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.social.topCards.matriculaCrecheCardFooter')" icon="fa fa-child boldness cor1" ></sp-card>
        <sp-card :valor="orcamentoEducacao" :descricao="$t('eixos.social.topCards.fundosEduTitle')" classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.social.topCards.fundosEduFooter')" icon="fa fa-money boldness cor1"></sp-card>
        <sp-card :valor="totalEscolas" :descricao="$t('eixos.social.topCards.escolasTitle')" classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.social.topCards.escolasFooter')" icon="fa fa-graduation-cap boldness cor1" ></sp-card>
        <sp-card :valor="numerosRedeEnsino.totalMatriculas" :descricao="$t('eixos.social.topCards.matriculaRedeCard')" classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.social.topCards.matriculaRedeCardFooter')" icon="fa fa-pencil boldness cor1" ></sp-card>
      </div>
      <div id='paineis-sms' class="row">
        <div class="flex lg6 md6 sm12">
          <sp360-list fit :image="candy" :title="$t('eixos.social.lists.medicamentosTitle')" :footerComplementar="$t('eixos.social.lists.medicamentosTitle')" :footerText="refSME">
            <template v-for="(m, index) in medicamentosCriticosList" class="list">
              <va-item>
                <va-item-section>
                  <va-item-label>
                    {{m.medicamento}}
                  </va-item-label>
                  <va-item-label caption>
                    Consumo médio mensal: {{separar(m.cmm)}} unidades | Farmácias com estoque : {{separar(m.presenca_farmacias)}}
                  </va-item-label>
                </va-item-section>
              </va-item>
              <va-list-separator v-if="index < medicamentosCriticosList.length-1" />
            </template>
            <br>
            <va-button v-show="medicamentosCriticosList.length" outline color="danger" class="pull-right"
              @click="openModalMedicamentos($event)">{{$t('eixos.social.lists.medicamentosButton')}} </va-button>
              <br>
              <br>
          </sp360-list>
        </div>
        <div class="flex lg6 md6 sm12">
          <sp360-list fit :image="shelf" :title="$t('eixos.social.lists.farmaciasTitle')" :footerComplementar="$t('eixos.social.lists.farmaciasTitle')" :footerText="refSME">
            <template v-for="(f, index) in farmaciasCriticasList" class="list">
              <va-item>
                <va-item-section>
                  <va-item-label>
                    {{f.unidade}}
                  </va-item-label>

                  <va-item-label caption>
                    {{getNomeSub(f.id_sub) +" | "+ f.perc_estoque +"%"}}
                  </va-item-label>
                </va-item-section>
              </va-item>
              <va-list-separator v-if="index < farmaciasCriticasList.length-1 " />
            </template>
            <br>
              <va-button v-show="farmaciasCriticasList.length" outline color="danger" class="pull-right" style="margin-bottom: 1em"
                @click="openModalFarmacias($event)"> {{$t('eixos.social.lists.farmaciasButton')}} </va-button>
              <br>
              <br>
          </sp360-list>
        </div>
      </div>
      <div id='paineis-sme' class="row">
        <div class="flex md4 lg4 sm12 inside">
          <sp-360-panel :image="creche" :title="$t('eixos.social.bottomPanels.crechePanel')" :footerComplementar="$t('eixos.social.bottomPanels.crechePanel')" :footerText="refSME">
            <h1 class="boldness">{{separar(filaCreche.solicitacoesCadastro)}} </h1>
            <div>
                <ul v-for="sub in listCreche">
                  <va-list-separator/>
                  <li><a class="enfase">{{separar(sub.solicitacoesCadastro)}}</a> - {{sub.nome}} - {{splitDREName(sub.nome_dre)}}</li>
                </ul>
            </div>
          </sp-360-panel>
        </div>
        <div class="flex md4 lg4 sm12 inside">
          <sp-360-panel :title="$t('eixos.social.bottomPanels.crecheChart')" :footerComplementar="$t('eixos.social.bottomPanels.crecheChart')" :footerText="refSME">
            <sp360-chart :data="piechartdeficitcreche" type="pie" :options="piechartdeficitcrecheOptions" />
          </sp-360-panel>
        </div>
        <div class="flex md4 lg4 sm12 inside">
          <div class="container">
            <div class="row topCardGrid">
              <sp-card :valor="numerosRedeEnsino.totalMatriculasCreche" :descricao="$t('eixos.social.bottomPanels.matriculaCrecheCard')" :lgGrid="6" stripe=' ' tema="info"/>
              <sp-card :valor="numerosRedeEnsino.unidadesCreches" :descricao="$t('eixos.social.bottomPanels.matriculaRedeCard')" :lgGrid="6" stripe=' ' tema="success"/>
            </div>
            <div class="md12 lg12 sm12" style="text-align: justify;">
              <sp-360-panel :title="$t('eixos.social.bottomPanels.notasTecnicasTitle')" :footerText="refSME" >
                <p>{{$t('eixos.social.bottomPanels.notasTecnicasContent')}}</p>
              </sp-360-panel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modals">
      <va-modal show.sync="true" ref="modalMedicamentos" :okText="'fechar'" :okClass="'btn btn-primary btn-sm'"
        size="large" v-model="showModalMedicamentos"
        :title="$t('eixos.social.tabelaEstoque.medicamentoSituacao')" :cancelText="''">
        <template slot="default">
          <sp360-data-table id="tabelaEstoqueMedicamentos" ref="tabelaEstoqueMedicamentos" :data="filtrarMedicamento"
            :fields="tableFieldsEstoqueMedicamentos" :perPage="itemsPerPage" :onEachSide="onEachSide"
            :dataModeFilterableFields="dataModeFilterableFields" :sortFunctions="sortFunctions" :filterInputShown="true"/>
        </template>
      </va-modal>
      <va-modal ref="modalFarmacia" :okText="'fechar'" :okClass="'btn btn-primary btn-sm'" :cancelText="''"
        size="large" v-model="showModalFarmacias" :title="$t('eixos.social.tabelaEstoque.farmaciaSituacao')">
        <template slot="default">
          <sp360-data-table id="tabelaEstoqueMedicamentos" ref="tabelaEstoqueMedicamentos" :data="filtrarUnidades"
            :fields="tableFieldsEstoquePorUnidade" :perPage="itemsPerPage" :onEachSide="onEachSide"
            :dataModeFilterableFields="dataModeFilterableFields" :sortFunctions="sortFunctions" :filterInputShown="true"
            />
        </template>
      </va-modal>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import MethGlob from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import Donut from '@/components/statistics/charts/GraficoDonut.vue'
import CorUtils from '@/utils/CorUtils'

import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360List from '@/components/ui/list/VaList'
// IMG
import pills from '@/assets/images/pills.jpg'
import shelf from '@/assets/images/medshelf.jpg'
import creche from '@/assets/images/creche.jpg'
import candy from '@/assets/images/candy.jpg'

export default {
  name: 'eixo-social',
  components: {
    Donut,
    SpCard,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Sp360List,
    Constantes,
  },
  data () {
    return {
      // IMG
      shelf: shelf,
      pills: pills,
      candy: candy,
      creche: creche,

      // SMS
      estoquePorMedicamento: [],
      estoquePorFarmacia: [],
      medicamentosCriticosList: [],
      farmaciasCriticasList: [],
      farmacia: null,
      medicamento: null,

      // SME
      filaCreche: {},
      listCreche: [],
      numerosRedeEnsino: {},
      piechartdeficitcreche: {},
      piechartdeficitcrecheOptions: {},
      redeEnsino: [],
      refSME: '',

      // Populacao
      populacaoTotal: 0,
      // Financas
      orcamentoSaude: null,
      orcamentoEducacao: null,
      // Tabelas dos Modais
      showModalMedicamentos: false,
      showModalFarmacias: false,
      termA: null,
      termB: null,
      termMedicamentos: '',
      termUnidade: '',
      onEachSide: 1,
      dadosTabelaEstoqueRemedio: [],
      dadosTabelaEstoquePorUnidade: [],
      itemsPerPage: Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.TAMANHO_TABELAS,
      tableFieldsEstoqueMedicamentos: [
        {
          name: 'medicamento',
          sortField: 'medicamento',
          title: this.$t('graficosSaude.tableFields.medicamento'),
          width: '54%',
        },
        {
          name: 'cmm',
          sortField: 'cmm',
          title: this.$t('graficosSaude.tableFields.cmm'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
        {
          name: 'estoque',
          sortField: 'estoque',
          title: this.$t('graficosSaude.tableFields.estoque'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
        {
          name: 'cobertura_rede_dias',
          sortField: 'cobertura_rede_dias',
          title: this.$t('graficosSaude.tableFields.cobertura_rede_dias'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
        {
          name: 'presenca_farmacias',
          sortField: 'presenca_farmacias',
          title: this.$t('graficosSaude.tableFields.presenca_farmacias'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
        {
          name: 'perc_estoque',
          sortField: 'perc_estoque',
          title: this.$t('graficosSaude.tableFields.perc_estoque'),
          callback: function (x) { return MethGlob.formataPercentual(x) },
          width: '6%',
        },

      ],
      tableFieldsEstoquePorUnidade: [
        {
          name: 'unidade',
          sortField: 'unidade',
          title: this.$t('graficosSaude.tableFields.unidade'),
          width: '76%',
        },
        {
          name: 'id_sub',
          sortField: 'id_sub',
          title: 'subPrefeitura',
          callback: function (x) {
            var a = SPMapaNomes.find(e => {
              if (e.id === x) {
                return e
              };
            })
            return a ? a.nome : 'não encontrado'
          },
          width: '12%',
        },
        {
          name: 'cmm',
          sortField: 'cmm',
          title: this.$t('graficosSaude.tableFields.cmm'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
        {
          name: 'perc_estoque',
          sortField: 'perc_estoque',
          title: this.$t('graficosSaude.tableFields.perc_estoque_medicamento'),
          callback: function (x) { return MethGlob.formataPercentual(x) },
          width: '6%',
        },
      ],
      dataModeFilterableFields: ['medicamento'],
      sortFunctions: {
        'medicamento': MethGlob.ordenaTabela,
        'cmm': MethGlob.ordenaTabelaParseInt,
        'estoque': MethGlob.ordenaTabelaParseInt,
        'cobertura_rede_dias': MethGlob.ordenaTabelaParseInt,
        'presenca_farmacias': MethGlob.ordenaTabelaParseInt,
        'perc_estoque': MethGlob.ordenaTabelaParseFloat,
      },
      dataModeFilterableFieldsPorUnidade: ['unidade', 'id_sub'],
      sortFunctionsPorUnidade: {
        'id_sub': MethGlob.ordenaTabela,
        'unidade': MethGlob.ordenaTabela,
        'cmm': MethGlob.ordenaTabelaParseInt,
        'perc_estoque': MethGlob.ordenaTabelaParseFloat,
      },
    }
  },
  computed: {
    filtrarMedicamento () {
      let a = []
      a = this.filterByValue(this.dadosTabelaEstoqueRemedio, this.termMedicamentos)
      return a.length ? a : this.dadosTabelaEstoqueRemedio
    },
    filtrarUnidades () {
      let a = []
      a = this.filterByValue(this.dadosTabelaEstoquePorUnidade, this.termUnidade)
      return a.length ? a : this.dadosTabelaEstoquePorUnidade
    },
    totalFarmacias () {
      return this.estoquePorFarmacia.length
    },
    totalEscolas () {
      return this.redeEnsino.length || 0
    },
  },
  created () {
    Promise.all([
      this.$store.dispatch('saude/buscarEstoqueDeRemedios'),
      this.$store.dispatch('saude/buscarEstoqueDeRemediosPorUnidade'),
      this.$store.dispatch('servicosSME/buscarFilaCreche', { intervalo: 'MAIS_RECENTE' }),
      this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'NENHUM' }),
      this.$store.dispatch('populacao/buscarPopulacaoPorIdadeSexo'),
      this.$store.dispatch('orcamento/buscarFinancasEixoSocial'),

    ])

      .then((respostas) => {
        this.refSME = this.$t('rodape.fonteData', { fonte: respostas[2].sigla_orgao + '-' + respostas[2].fonte, data: new Date(respostas[2].data_referencia_dado).toLocaleDateString('pt-BR') })
        this.refSMS = this.$t('rodape.fonteData', { fonte: respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte, data: new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR') })
        this.refSMIT = this.$t('rodape.fonteData', { fonte: respostas[5].data.sigla_orgao + '-' + respostas[5].data.fonte, data: new Date(respostas[5].data.data_referencia_dado).toLocaleDateString('pt-BR') })

        this.$emit('updated', new Date())
        // SMS
        this.estoquePorMedicamento = _.orderBy(respostas[0].data.data, ['perc_estoque'], 'asc')

        this.estoquePorFarmacia = _.orderBy(respostas[1].data.data, ['perc_estoque'], 'asc')
        // lista
        this.medicamentosCriticosList = _.filter(this.estoquePorMedicamento, (o) => { return o.perc_estoque <= 10 }).slice(0, 5)
        this.farmaciasCriticasList = _.filter(this.estoquePorFarmacia, (o) => { return o.perc_estoque <= 10 }).slice(0, 5)
        // tabelaModal
        this.dadosTabelaEstoqueRemedio = _.filter(this.estoquePorMedicamento, (o) => { return o.perc_estoque <= 10 })
        this.dadosTabelaEstoquePorUnidade = _.filter(this.estoquePorFarmacia, (o) => { return o.perc_estoque <= 10 })
        // SME
        this.dados = _.orderBy(respostas[2].data, [ o => (o.bercario_i + o.bercario_ii + o.mini_grupo_ii + o.mini_grupo_i) ], 'desc')
        this.listCreche = this.dados.slice(0, 5)
        this.filaCreche = this.calcularTotalizadores(this.dados)
        this.populatePiechartDeficitCreche(this.filaCreche)
        this.redeEnsino = respostas[3].data
        this.numerosRedeEnsino = this.calculaRedeEnsino(respostas[3].data)

        // Populacao
        this.populacaoTotal = _.reduce(respostas[4].data.data[0].dados, (acc, el) => { return acc + (el.masculino + el.feminino) }, 0)

        // Finanças
        this.orcamentoSaude = MethGlob.formatarGrandesNumeros(respostas[5].data.data['saude_disponivel'])
        this.orcamentoEducacao = MethGlob.formatarGrandesNumeros(respostas[5].data.data['educacao_disponivel'])
      })
      .catch((error) => {
        console.error(error)
      })

    this.topTooltipOptionsTabela = { content: this.$t('graficosSaude.tooltipGraficoEstoqueMedicamentos'), placement: 'bottom', classes: 'va-tooltip customTooltip' }
    this.topTooltipOptionsTabelaPorUnidade = { content: this.$t('graficosSaude.tooltipGraficoEstoqueMedicamentosPorUnidade'), placement: 'bottom', classes: 'va-tooltip customTooltip' }
    this.donutTooltipEstoqueRemedio = { content: this.$t('graficosSaude.tooltipDonutEstoqueMedicamentos'), placement: 'bottom', classes: 'va-tooltip customTooltip' }
    this.donutTooltipPorFarmacia = { content: this.$t('graficosSaude.tooltipDonutEstoqueMedicamentosPorUnidade'), placement: 'bottom', classes: 'va-tooltip customTooltip' }
  },

  methods: {
    rodapeData (d, data) {
      return MethGlob.rodapeData(d, data)
    },
    separar (valor) { return !isNaN(valor) ? MethGlob.thousandSeparator(valor) : valor },

    // SMS
    openModalFarmacias (event) {
      this.showModalFarmacias = !this.showModalFarmacias
    },
    openModalMedicamentos (event) {
      this.showModalMedicamentos = !this.showModalMedicamentos
    },

    // SME
    splitDREName (nomeDre) {
      return 'D.R.E. ' + nomeDre.split('DIRETORIA REGIONAL DE EDUCACAO ')[1]
    },
    populatePiechartDeficitCreche () {
      let cores = [
        CorUtils.getCorPorNomeSp360('verde-limao-medio'),
        CorUtils.getCorPorNomeSp360('amarelo-bistre-medio'),
        CorUtils.getCorPorNomeSp360('azul-columbia-medio'),
        CorUtils.getCorPorNomeSp360('azul-glauco-medio'),
      ]

      cores = _.shuffle(cores)
      this.piechartdeficitcreche = {} // Definir o Objeto do chart antes de definir os valores cessa o erro do chart só desenhar apos um resize
      this.piechartdeficitcreche.labels = [
        this.$t('eixos.social.distribuicaoFilaCreche.deficitMenor1Ano'),
        this.$t('eixos.social.distribuicaoFilaCreche.deficit1Ano'),
        this.$t('eixos.social.distribuicaoFilaCreche.deficit2Anos'),
        this.$t('eixos.social.distribuicaoFilaCreche.deficit3Anos'),
      ]
      this.piechartdeficitcreche.datasets = []
      let dataset = {
        backgroundColor: cores,
        data: [
          this.filaCreche.bercario_i,
          this.filaCreche.bercario_ii,
          this.filaCreche.mini_grupo_i,
          this.filaCreche.mini_grupo_ii,
        ],
      }
      this.piechartdeficitcrecheOptions = {
        legend: {
          labels: { font: 8, usePointStyle: true },
          position: 'bottom',
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'pie'),
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => value ? MethGlob.formataPercentual(value * 100 / this.filaCreche.solicitacoesCadastro) + '\n ' + MethGlob.thousandSeparator(parseFloat(value)) : null,
            clamp: true,
            display: 'auto',
            anchor: 'center',
            font: {
              size: 14,
              weight: 'bold',
            },
          },
        },
      }
      this.piechartdeficitcreche.datasets.push(dataset)
    },

    calcularTotalizadores (filaCreche) {
      let arr = []
      let totais = this.getTotalizador()
      filaCreche.forEach(creche => {
        creche.solicitacoesCadastro = (creche.bercario_i + creche.bercario_ii + creche.mini_grupo_ii + creche.mini_grupo_i)
        arr.push(creche.solicitacoesCadastro)
        totais = this.redutor(totais, creche)
      })
      totais.solicitacoesCadastro = (totais.bercario_i + totais.bercario_ii + totais.mini_grupo_i + totais.mini_grupo_ii)
      totais.pontosCentrais = MethGlob.calculaPontosCentrais(arr)
      return totais
    },

    getTotalizador () {
      return {
        pontosCentrais: {},
        solicitacoesCadastro: 0,
        bercario_i: 0,
        bercario_ii: 0,
        mini_grupo_i: 0,
        mini_grupo_ii: 0,
        demandaBercario: 0,
        demandaJardim: 0,
        MaiorDeficit: {
          bercario_i: {},
          bercario_ii: {},
          mini_grupo_i: {},
          mini_grupo_ii: {},
        },
      }
    },

    redutor (acumulador, n) {
      acumulador.bercario_i += n.bercario_i
      acumulador.bercario_ii += n.bercario_ii
      acumulador.mini_grupo_i += n.mini_grupo_i
      acumulador.mini_grupo_ii += n.mini_grupo_ii
      acumulador.demandaBercario += n.bercario_i + n.bercario_ii
      acumulador.demandaJardim += n.mini_grupo_i + n.mini_grupo_ii
      return acumulador
    },

    getNomeSub: function (id_sub) {
      return typeof id_sub === 'number' ? SPMapaNomes[id_sub].nome : 'não encontrado'
    },

    calculaRedeEnsino (dados) {
      let totais = { totalMatriculas: 0, totalMatriculasCreche: 0, unidadesCreches: 0 }
      dados.forEach((e) => {
        totais.totalMatriculas += e.total_matriculas || 0
        totais.totalMatriculasCreche += e.total_matriculas_creche || 0
        totais.unidadesCreches += (e.total_matriculas_creche) ? 1 : 0
      })
      return totais
    },

    // TabelasModais
    searchA: _.debounce(function (term) {
      this.termMedicamentos = term
    }, 400),

    searchB: _.debounce(function (term) {
      this.termUnidade = term
    }, 400),

    filterByValue (array, string) {
      return _.filter(array, (obj) => {
        return Object.keys(obj).reduce((acc, curr) => {
          if (typeof obj[curr] === 'string') {
            string.trim()
            return acc || obj[curr].toLowerCase().includes(string.trim().toLowerCase())
          }
          if (typeof obj[curr] === 'number') {
            let a = _.find(SPMapaNomes, (e) => { return (e.id === obj[curr] && e.nome === string) && e.nome })
            if (a) return acc || a
            return acc || obj[curr] <= parseInt(string)
          }
        }, false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .img-card {
    .va-card__image{
        padding-bottom: 50% !important;
    }
  }

  .list {
    padding: 0.02rem
  }

  .boldness{
      font-size: 2.5vw;
      font-weight: 900;
      @include media-breakpoint-down(sm) {
        font-size: 7.5vw;
      }
  }

  .enfase{
      font-size: 1rem;
      font-weight: 900;
  }

  .va-chart{
    max-height:20.8rem ;
  }

</style>
